import React from 'react';
import {
  Box,
  Button,
  CardContent,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Tooltip
} from '@mui/material';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const objectToCsv = function (data) {
  if (!data || data.length === 0) return '';

  const csvRows = [];
  const headers = Object.keys(data[0]);

  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header] === null || row[header] === undefined ? '' : row[header];
      return `"${String(val).replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class SalesOrderView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client('none'),
      saleslocation_list: [],
      irefOrder: 0,
      page: 0,
      rowsPerPage: -1,
      sx_hidden: { display: 'none' },
      value: '1',
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      iref: this.state.irefOrder
    };

    let data = BackofficeReportsApi.getOrdersDetail(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  setOrder = event => {
    let iref = event.target.value;

    if (!Number(iref)) {
      return;
    }

    this.setState({
      irefOrder: iref
    });
  };

  onDownload = () => {
    if (!this.state.saleslocation_list.result) return;

    const link = document.createElement('a');
    link.download = 'orderView_' + this.state.irefOrder + '.csv';

    let csvData = [];

    if (
      this.state.saleslocation_list.result.orderlines &&
      this.state.saleslocation_list.result.orderlines.length > 0
    ) {
      csvData = objectToCsv(this.state.saleslocation_list.result.orderlines);
    }

    let csvHeader =
      'Order: ' +
      this.state.irefOrder +
      '\nLocation: ' +
      this.state.saleslocation_list.result.location +
      '\nDate: ' +
      this.state.saleslocation_list.result.date +
      '\nValue: ' +
      this.state.saleslocation_list.result.valueWVat +
      '\nValueNoVAT: ' +
      this.state.saleslocation_list.result.valueWoVat +
      '\n';

    let csv = '\uFEFF' + csvHeader + '\n' + csvData;

    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let productSalesList = [];
    let fOrder = [];

    if (this.state.saleslocation_list.result) {
      fOrder = this.state.saleslocation_list.result;

      if (this.state.saleslocation_list.result.orderlines) {
        Object.keys(this.state.saleslocation_list.result.orderlines).forEach(key => {
          let fData = this.state.saleslocation_list.result.orderlines[key];

          if (fData.index > 0) {
            let p = {
              id: fData.index,
              product: fData.productName,
              quantity: fData.quantity,
              price: parseFloat(
                parseFloat(fData.productValue) + parseFloat(fData.vat / fData.quantity)
              ).toFixed(2),
              value: parseFloat(fData.value).toFixed(2),
              valueNoVAT: parseFloat(fData.valueNoVAT).toFixed(2)
            };

            productSalesList.push(p);
          }
        });
      }
    }

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.75,
        md: 0.8
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums'
    };

    const headerCellSx = {
      py: {
        xs: 0.5,
        sm: 0.7,
        md: 0.85
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip'
    };

    const iconButtonSx = {
      minWidth: 36,
      width: 36,
      height: 36,
      p: 0,
      flexShrink: 0,
      borderRadius: '12px',
      color: '#1a237e',
      bgcolor: 'rgba(26, 35, 126, 0.08)',
      boxShadow: 'none',
      border: '1px solid rgba(26, 35, 126, 0.12)',
      '&:hover': {
        bgcolor: 'rgba(26, 35, 126, 0.12)',
        boxShadow: 'none'
      }
    };

    return (
      <CardContent
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          minHeight: 0,
          p: '0 !important',
          borderRadius: {
            xs: '14px',
            sm: '16px'
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: '#fff'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
              md: 1.25
            },
            py: {
              xs: 0.65,
              sm: 0.75
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center'
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1
              },
              flexDirection: {
                xs: 'column',
                sm: 'row'
              }
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                    md: '1.05rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Order Detail
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Search by order number and review order lines
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                  xs: 'flex-start',
                  sm: 'flex-end'
                },
                gap: 0.75,
                flexWrap: 'wrap',
                flexShrink: 0
              }}
            >
              <TextField
                label="OrderNo"
                size="small"
                id="OrderNo"
                sx={{
                  width: {
                    xs: 130,
                    sm: 140
                  },
                  flexShrink: 0,
                  '& .MuiInputBase-root': {
                    height: 36,
                    borderRadius: '12px',
                    fontSize: {
                      xs: '1rem',
                      sm: '0.88rem'
                    },
                    bgcolor: '#fff'
                  }
                }}
                inputProps={{
                  min: 0,
                  style: {
                    textAlign: 'center'
                  }
                }}
                onChange={this.setOrder}
                required={true}
              />

              <Tooltip title="Search order">
                <Button
                  size="small"
                  onClick={this.getData}
                  variant="contained"
                  sx={iconButtonSx}
                >
                  <SearchIcon fontSize="small" />
                </Button>
              </Tooltip>

              <Tooltip title="Download CSV">
                <Button
                  size="small"
                  onClick={this.onDownload}
                  variant="contained"
                  sx={iconButtonSx}
                >
                  <FileDownloadIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            px: {
              xs: 0.75,
              sm: 1
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)'
          }}
        >
          <TableContainer
            sx={{
              overflowX: 'auto',
              overflowY: 'hidden',
              width: '100%',
              border: '1px solid rgba(15, 23, 42, 0.06)',
              borderRadius: '12px',
              '& .MuiTableCell-root': {
                borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
                fontSize: {
                  xs: '0.76rem',
                  sm: '0.84rem',
                  md: '0.9rem'
                }
              }
            }}
          >
            <Table
              stickyHeader
              size="small"
              aria-label="order summary table"
              sx={{
                minWidth: {
                  xs: 700,
                  sm: 780,
                  md: '100%'
                },
                width: '100%',
                tableLayout: {
                  xs: 'fixed',
                  md: 'auto'
                }
              }}
            >
              <TableHead>
                <TableRow>
                  {[
                    ['Order', { xs: 72, sm: 82, md: '9%' }, 'center'],
                    ['Location', { xs: 135, sm: 170, md: '22%' }, 'left'],
                    ['Date', { xs: 150, sm: 165, md: '17%' }, 'left'],
                    ['Delivery', { xs: 95, sm: 110, md: '13%' }, 'left'],
                    ['Value', { xs: 85, sm: 95, md: '12%' }, 'center'],
                    ['Value No VAT', { xs: 105, sm: 115, md: '15%' }, 'center'],
                    ['Lines', { xs: 62, sm: 72, md: '12%' }, 'center']
                  ].map(([label, width, align]) => (
                    <TableCell
                      key={label}
                      align={align}
                      sx={{
                        ...headerCellSx,
                        width
                      }}
                    >
                      {label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow hover>
                  <TableCell align="center" sx={bodyCellSx}>
                    {fOrder.order}
                  </TableCell>

                  <TableCell align="left" sx={bodyCellSx}>
                    {fOrder.location}
                  </TableCell>

                  <TableCell align="left" sx={bodyCellSx}>
                    {fOrder.date}
                  </TableCell>

                  <TableCell align="left" sx={bodyCellSx}>
                    {fOrder.delivery}
                  </TableCell>

                  <TableCell align="center" sx={bodyCellSx}>
                    {fOrder.valueWVat ? parseFloat(fOrder.valueWVat).toFixed(2) : 0}
                  </TableCell>

                  <TableCell align="center" sx={bodyCellSx}>
                    {fOrder.valueWoVat ? parseFloat(fOrder.valueWoVat).toFixed(2) : 0}
                  </TableCell>

                  <TableCell align="center" sx={bodyCellSx}>
                    {fOrder.lines}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            overflowX: 'auto',
            overflowY: 'auto',
            width: '100%',
            '& .MuiTableCell-root': {
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              fontSize: {
                xs: '0.78rem',
                sm: '0.88rem',
                md: '0.92rem'
              }
            },
            '& .MuiTableRow-hover:hover': {
              backgroundColor: 'rgba(26, 35, 126, 0.035)'
            }
          }}
        >
          <Table
            stickyHeader
            size="small"
            aria-label="order lines table"
            sx={{
              minWidth: {
                xs: 610,
                sm: 720,
                md: '100%'
              },
              width: '100%',
              tableLayout: {
                xs: 'fixed',
                md: 'auto'
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    ...headerCellSx,
                    position: 'sticky',
                    left: 0,
                    zIndex: 4,
                    width: {
                      xs: 72,
                      sm: 82,
                      md: '10%'
                    }
                  }}
                >
                  Index
                </TableCell>

                {[
                  ['Product', { xs: 185, sm: 250, md: '40%' }, 'left'],
                  ['Quantity', { xs: 82, sm: 95, md: '12%' }, 'center'],
                  ['Price', { xs: 82, sm: 95, md: '12%' }, 'center'],
                  ['Value', { xs: 82, sm: 95, md: '12%' }, 'center'],
                  ['Value No VAT', { xs: 105, sm: 115, md: '14%' }, 'center']
                ].map(([label, width, align]) => (
                  <TableCell
                    key={label}
                    align={align}
                    sx={{
                      ...headerCellSx,
                      width
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? productSalesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : productSalesList
              ).map(product => {
                return (
                  <TableRow hover key={product.id} tabIndex={-1}>
                    <TableCell
                      align="center"
                      sx={{
                        py: {
                          xs: 0.55,
                          sm: 0.75,
                          md: 0.8
                        },
                        px: {
                          xs: 0.35,
                          sm: 0.65,
                          md: 1
                        },
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        bgcolor: '#fff',
                        whiteSpace: 'nowrap',
                        color: '#111827',
                        fontWeight: 550,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: {
                          xs: 72,
                          sm: 82,
                          md: '10%'
                        }
                      }}
                    >
                      {product.id}
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        ...bodyCellSx,
                        fontSize: {
                          xs: '0.72rem',
                          sm: '0.84rem',
                          md: '0.92rem'
                        },
                        maxWidth: {
                          xs: 185,
                          sm: 250,
                          md: 'none'
                        }
                      }}
                    >
                      {product.product}
                    </TableCell>

                    <TableCell align="center" sx={bodyCellSx}>
                      {product.quantity}
                    </TableCell>

                    <TableCell align="center" sx={bodyCellSx}>
                      {product.price}
                    </TableCell>

                    <TableCell align="center" sx={bodyCellSx}>
                      {product.value}
                    </TableCell>

                    <TableCell align="center" sx={bodyCellSx}>
                      {product.valueNoVAT}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={productSalesList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            flexShrink: 0,
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            minHeight: {
              xs: 44,
              sm: 52
            },
            overflow: 'hidden',
            '& .MuiTablePagination-toolbar': {
              minHeight: {
                xs: 44,
                sm: 52
              },
              px: {
                xs: 0.5,
                sm: 1
              },
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap'
              },
              gap: {
                xs: 0.25,
                sm: 0.5
              }
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              fontSize: {
                xs: '0.88rem',
                sm: '0.92rem',
                md: '1rem'
              },
              m: 0
            },
            '& .MuiTablePagination-actions': {
              ml: {
                xs: 0,
                sm: 1
              }
            }
          }}
        />
      </CardContent>
    );
  }
}

export default SalesOrderView;
